var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ebeec906-d368-4d60-86cc-4e2c7fcfb0e3",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318.9 245.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ffe72f3e-c17d-484e-bf85-82ba64d70db8{fill:#fff;}.f4a9a3f6-4930-4867-80bc-a5dc6de93b29{fill:url(#ad7b987d-3e67-498b-a00b-a0fb6b66e987);}.b1c60da7-56e0-4ba5-80b8-1c78503ef1e6{fill:url(#ec163a50-62dc-4ffb-8fa5-c0496a03e14c);}.bdc1c29b-0e96-43f2-87fb-1081b126c2ab{fill:url(#a23628a7-fc34-43a0-a431-cd4af3c8e9ba);}.a88f30f1-859c-483e-9f0c-ac4fedafd751{fill:url(#eadf88fa-b2df-4d2f-9969-594ab6b1b7da);}.f33f4ebd-4c6d-4fc3-8e76-5359af172114{fill:url(#ba0655dc-8166-4815-ac38-da7864bcc69b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad7b987d-3e67-498b-a00b-a0fb6b66e987",
    x1: 244.12,
    y1: 151.1,
    x2: 322.01,
    y2: 151.1,
    gradientTransform: "translate(-24.9 -18.2) scale(1.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#209348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#50b047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62bb46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ec163a50-62dc-4ffb-8fa5-c0496a03e14c",
    x1: 244.12,
    y1: 138.97,
    x2: 322.01,
    y2: 138.97,
    xlinkHref: "#ad7b987d-3e67-498b-a00b-a0fb6b66e987"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a23628a7-fc34-43a0-a431-cd4af3c8e9ba",
    x1: 244.12,
    y1: 125.75,
    x2: 322.01,
    y2: 125.75,
    xlinkHref: "#ad7b987d-3e67-498b-a00b-a0fb6b66e987"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eadf88fa-b2df-4d2f-9969-594ab6b1b7da",
    x1: 69.74,
    y1: 138.97,
    x2: 148.84,
    y2: 138.97,
    gradientTransform: "translate(-24.9 -18.2) scale(1.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#2e3a7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0d66ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba0655dc-8166-4815-ac38-da7864bcc69b",
    x1: 156.52,
    y1: 138.97,
    x2: 233.34,
    y2: 138.97,
    gradientTransform: "translate(-24.9 -18.2) scale(1.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#743237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ab263e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#db1c44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed1846"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ffe72f3e-c17d-484e-bf85-82ba64d70db8",
    d: "M354.8,211.4A49.6,49.6,0,0,1,305.2,261H35.9V64.9A49.7,49.7,0,0,1,85.6,15.3H354.8Z",
    transform: "translate(-35.9 -15.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f4a9a3f6-4930-4867-80bc-a5dc6de93b29",
    d: "M267,161.2h20.6a9.9,9.9,0,0,0,2.4-.3,9.1,9.1,0,0,0,7.2-9.1,9.3,9.3,0,0,0-7.2-9.1l-2.4-.2H267Z",
    transform: "translate(-35.9 -15.3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b1c60da7-56e0-4ba5-80b8-1c78503ef1e6",
    d: "M285.2,31.9a35.4,35.4,0,0,0-35.5,35.4v36.8h53.6c11.4.6,19.8,6.4,19.8,16.5,0,8-5.8,14.8-16.2,16.3v.4c11.5.8,20.3,7.1,20.3,17.1s-9.6,17.7-22.5,17.7h-55v72.3h52A35.4,35.4,0,0,0,337.1,209V31.9Z",
    transform: "translate(-35.9 -15.3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bdc1c29b-0e96-43f2-87fb-1081b126c2ab",
    d: "M294.8,123.3a8.5,8.5,0,0,0-7.1-8.5H267v17.2h20.7A8.5,8.5,0,0,0,294.8,123.3Z",
    transform: "translate(-35.9 -15.3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a88f30f1-859c-483e-9f0c-ac4fedafd751",
    d: "M89.1,31.9A35.3,35.3,0,0,0,53.7,67.3v87.5c9.9,4.8,20.2,7.9,30.6,7.9,12.3,0,19-7.4,19-17.5V104.1h30.5v41.1c0,16.1-9.9,29-43.8,29a151.9,151.9,0,0,1-36.3-4.4v74.7h51.9A35.5,35.5,0,0,0,141.1,209V31.9Z",
    transform: "translate(-35.9 -15.3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f33f4ebd-4c6d-4fc3-8e76-5359af172114",
    d: "M187.1,31.9a35.4,35.4,0,0,0-35.4,35.4v46.4c9-7.7,24.5-12.5,49.7-11.4a161.7,161.7,0,0,1,27.8,4.2v15a68.5,68.5,0,0,0-26.8-7.8c-19.1-1.5-30.7,7.9-30.7,24.5s11.6,25.9,30.7,24.4a69.7,69.7,0,0,0,26.8-7.8v15a161.7,161.7,0,0,1-27.8,4.2c-25.2,1.2-40.7-3.7-49.7-11.4v81.9h52A35.5,35.5,0,0,0,239.1,209V31.9Z",
    transform: "translate(-35.9 -15.3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.b3164d731c8f3c5fb861ccede0ec9228.svg";
export { ForwardRef as ReactComponent };